export default __webpack_public_path__ + "static/media/Hero Core - Main Logo.7c6d13a8.svg";